module.exports = __webpack_public_path__ + "static/assets/3d538e405356e92b026bce362a653e53.svg";